// eslint-disable-next-line no-undef
const BUILD_VERSION = YSS_APP_VERSION;

const getDefaultSettingState = () => {
	return {
		/* 登入狀態 */
		auth: {
			/* 存取組織識別碼 */
			accessOUID: '',
			/* 存取用戶群識別碼 */
			accessGUID: '',
			/* 存取角色識別碼 */
			accessRole: '',
			/* 存取會員等級 （0:未驗證/ 1:一般網站會員/ 2:學會會員) */
			accessType: '',
			/* 存取用戶識別碼 */
			accessUID: '',
			/* 存取用戶代碼 */
			accessId: '',
			/* 存取用戶姓名 */
			accessName: '',
			/* 存取用戶單位 */
			accessUnit: '',
			/* 存取令牌 */
			accessToken: '',
			/* 逾期時間 */
			expTime: '',
			/* 登入訊息 */
			mesg: '',
			/* 最後登入 IP */
			lastIp: '',
			/* 最後登入城市 */
			lastCity: '',
			/* 最後登入時間 */
			lastTime: '',
			/* 現在登入城市 */
			currCity: '',
			/* 現在登入時間 */
			currTime: '',
			/* 本次登入浮水印追蹤碼 */
			traceCode: '',
			/* 是否登入中 */
			isLogin: false,
			/* 功能選單 */
			menus: [],
			/* platform app.config */
			sysconfig: {},
			/* organization app.config */
			appconfig: {},
			/* 跨頁面傳遞資料 */
			page: {
				label: '',
				icon: '',
				name: '',
				path: '',
				params: {}, // 重新整理時要讀取得參數
			},
			/* 裝置識別碼 */
			deviceid: '',
			/* 上一頁的路由 */
			lastRoute: '',
			/* 最近的訊息文字 */
			lastMessage: '',
		},
		/* 程式設定 */
		config: {
			/* 連線伺服器 */
			server: '',
			/* 版本 */
			appname: 'YouEvent365® Association Management System',
			/* 版本 */
			version: BUILD_VERSION,
			/* 語系 */
			lang: 'zh_tw',
			/* 依登入 orzuid 隔離的瀏覽器偏好 */
			accountPreferences: {},
			/* 畫面記憶 */
			layout: {
				/* dark mode */
				darkMode: false,
				/* theme color */
				themeColor: 'green',
				/* Layout fixed. Scroll content only */
				isFixed: true,
				/* Sidebar collapsed */
				isCollapsed: false,
				/* Boxed layout */
				isBoxed: false,
				/* Floating sidebar */
				isFloat: false,
				/* Sidebar show menu on hover only */
				asideHover: false,
				/* Show sidebar scrollbar (dont' hide it) */
				asideScrollbar: false,
				/* Sidebar collapsed with big icons and text */
				isCollapsedText: false,
				/* Toggle for the offsidebar */
				offsidebarOpen: false,
				/* Toggle for the sidebar offcanvas (mobile) */
				asideToggled: false,
				/* Toggle for the sidebar user block */
				showUserBlock: false,
				/* Enables layout horizontal */
				horizontal: false,
				/* Full size layout */
				useFullLayout: false,
				/* Hide footer */
				hiddenFooter: false,
			},
		},
	};
};

const SettingsModule = {
	namespaced: false,
	state: getDefaultSettingState(),
	getters: {
		getSetting(state) {
			return state;
		},
	},
	mutations: {
		resetSetting(state) {
			Object.keys(state).forEach(key => {
				delete state[key];
			});
			Object.assign(state, getDefaultSettingState());
		},
		toggleSetting(state, { group, name }) {
			const json = state[group];
			if (json !== undefined) {
				if (name in json) {
					json[name] = !json[name];
				}
			}
		},
		changeSetting(state, { group, name, value }) {
			const json = state[group];

			if (json !== undefined) {
				if (name in json) {
					json[name] = value;
				}
			}

			console.log(`change-setting, state.${group}.${name}`);
		},
		deleteSetting(state, { group, name }) {
			const json = state[group];

			if (json !== undefined) {
				if (name in json) {
					delete json[name];
				}
			}
		},
		changeSettingObject(state, { group, value }) {
			console.log(`change-setting-object, state.${group}`);

			// 刪除 state 上不在 value 裡的 key
			Object.keys(state[group]).forEach(key => {
				if (value !== undefined) {
					if (!(key in value)) {
						delete state[group][key];
					}
				}
			});
			// 再把 value 裡的屬性都 assign 過來
			Object.assign(state[group], value);
			if (group === 'config') {
				state.config.version = BUILD_VERSION;
			}
		},
		setAccountPreferences: (state, { orzuid, value }) => {
			if (!orzuid) return;

			state.config.accountPreferences = {
				...(state.config.accountPreferences || {}),
				[orzuid]: value,
			};
		},
		replaceSettings(state, { value }) {
			const defaultSettings = getDefaultSettingState();
			const nextValue = value
				? {
						...value,
						auth: {
							...defaultSettings.auth,
							...(value.auth || {}),
						},
				  }
				: defaultSettings;
			console.log('replace-settings');
			// 刪除 state 上不在 value 裡的 key
			Object.keys(state).forEach(key => {
				if (nextValue !== undefined) {
					if (!(key in nextValue)) {
						delete state[key];
					}
				}
			});
			// 再把 value 裡的屬性都 assign 過來
			Object.assign(state, nextValue);
			state.config = {
				...defaultSettings.config,
				...(state.config || {}),
				version: BUILD_VERSION,
			};
		},
	},
	actions: {
		resetSetting({ commit }) {
			commit('resetSetting');
		},
		toggleSetting({ commit }, { group, name }) {
			commit('toggleSetting', { group, name });
		},
		changeSetting({ commit }, { group, name, value }) {
			commit('changeSetting', { group, name, value });
		},
		deleteSetting({ commit }, { group, name }) {
			commit('deleteSetting', { group, name });
		},
		changeSettingObject({ commit }, { group, value }) {
			commit('changeSettingObject', { group, value });
		},
		setAccountPreferences: ({ commit }, { orzuid, value }) => {
			commit('setAccountPreferences', { orzuid, value });
		},
	},
};

export default SettingsModule;
